import { Banniere } from '@/model/banniere';
import Axios, { AxiosResponse } from 'axios';
import { ApiUtils } from './api-utils';

export type BanniereForm = { id: number, title: string, status: boolean }
export class BanniereApi {
  static getAllBannieres (): Promise<Banniere[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/bannieres'), [Banniere]);
  }
}
